module.exports = __webpack_public_path__ + "img/gaxon.b1a63de8.svg";